import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { Table } from "@pentabd/ui";

import { ButtonGroup, ErrorModal, SuccessModal } from "@components";

import {
  AddToStockType,
  // ProcurementsType,
  ProductType,
} from "@type/inventory/procurements";

import { addToStock } from "@api/inventory/productDetails";

import { ProcurementDetailsTableColumn } from "./ProcurementDetailsTableColumn";
// import useCustomSelector from "@redux/hooks/useCustomSelector";
// import useActionCreator from "@redux/hooks/useActionCreator";

type Props = {
  onAddTagOpen: (data: ProductType) => void;
  procurementData: any;
};
type StockResponse = {
  isLoading: boolean;
  error: any;
  data: any;
};

export const ProcurementDetailsTable = ({
  onAddTagOpen,
  procurementData,
}: Props) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const { procurementsState, handleQueryById } = procurementData;
  const { getSingleData } = procurementsState;

  const [activeType, setActiveType] = useState(0);
  const [productState, setProductState] = useState(getSingleData?.products);
  const [stockData, setStockData] = useState<StockResponse>({
    isLoading: false,
    error: null,
    data: null,
  });
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const filterButtons = t("PROCUREMENTS_DETAILS.TABLE.ACTION_BUTTONS", {
    returnObjects: true,
  }) as string[];

  const btnGroupAction = (index: any) => {
    setActiveType(index);
  };

  useEffect(() => {
    if (getSingleData?.products) {
      if (activeType === 0) {
        setProductState(getSingleData?.products);
      } else if (activeType === 1) {
        setProductState(
          getSingleData?.products.filter(
            (item: ProductType) => item.type === 1,
          ),
        );
      } else if (activeType === 2) {
        setProductState(
          getSingleData?.products.filter(
            (item: ProductType) => item.type === 2,
          ),
        );
      } else {
        setProductState(getSingleData?.products);
      }
    }
  }, [activeType, getSingleData]);

  useEffect(() => {
    setProductState(getSingleData?.products);
  }, [getSingleData]);

  const handleAddToStock = async (data: ProductType) => {
    const __data = {
      name: data?.name?.id,
      total: data?.amount,
      product: data?.id,
    };

    setStockData({
      isLoading: true,
      error: null,
      data: null,
    });
    const res = await addToStock(__data as AddToStockType);

    setStockData({
      isLoading: false,
      error: res.error,
      data: res.data,
    });
    if (res.data) {
      setIsSuccessModalOpen(true);
    }
    if (res.error) {
      setIsErrorModalOpen(true);
    }
  };

  const createSuccessAction = () => {
    handleQueryById(id || "");
    setIsSuccessModalOpen(false);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  return (
    <div className="mt-10">
      <Table
        header={{
          title: t("PROCUREMENTS_DETAILS.PRODUCT"),
          description: t("PROCUREMENTS_DETAILS.PRODUCT_DESCRIPTION"),
        }}
        columns={
          ProcurementDetailsTableColumn(
            t,
            onAddTagOpen,
            handleAddToStock,
            stockData.isLoading,
          ) as any
        }
        rows={productState || []}
        headerExtension={{
          leftComponents: [
            <ButtonGroup
              key="btn-group"
              btnGroupData={filterButtons}
              activeState={activeType}
              action={btnGroupAction}
            />,
          ],
          // rightComponents: [
          //   <div className="d-flex">
          //     <InputText
          //       name="simple-input"
          //       onChange={(e) => {
          //         console.log("onChange e:", e);
          //       }}
          //       prefix={<IconSearch fill="dark" size="20" />}
          //       size="sm"
          //       placeholder={t("PROCUREMENTS_DETAILS.TABLE.SEARCH")}
          //       type="text"
          //     />
          //     <Button
          //       fill="outline"
          //       type="light"
          //       size="sm"
          //       onClick={() => {
          //         console.log("filter button clicked");
          //       }}
          //       className="ms-5"
          //     >
          //       <IconFilterlines fill="dark" size="17" />
          //       {t("PROCUREMENTS_DETAILS.TABLE.FILTER")}
          //     </Button>
          //   </div>,
          // ],
        }}
        // pagination={{
        //   totalPage: Math.ceil(productState.length / 5),
        //   onClick: (currentPage) => {
        //     console.log("page change handler");
        //   },
        //   activePage: 1,
        // }}
      />

      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
        />
      )}
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
    </div>
  );
};

export default ProcurementDetailsTable;
